<template>
  <el-dialog
    :title="dialogType == 'add' ? '添加规则' : '编辑规则'"
    :visible.sync="visible"
    :close-on-click-modal="false"
    width="800px"
  >
    <div style="color: #ff8080;margin-bottom: 25px;">说明：根据用户估价下调和上调比例设置，计算用户估价的范围区间，区间默认向上取为整数便于展示</div>
    <el-form ref="form" :model="formData" :rules="rules" label-width="135px" label-position="left">
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="用户估价区间：" required>
            <div style="display:flex">
              <el-form-item label-width="0" prop="lower">
                <el-input v-model="formData.lower" placeholder="请输入起始值" />
              </el-form-item>
              <div style="margin:0 10px">~</div>
              <el-form-item label-width="0" prop="upper">
                <el-input v-model="formData.upper" placeholder="请输入结束值" />
              </el-form-item>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="左区间下调比例：" prop="leftSideRatio">
            <el-input v-model="formData.leftSideRatio" placeholder="请输入不大于100的数字" @input="limitInput($event, 'leftSideRatio', 100)">
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="最多下调：" prop="leftSideLimit" label-width="95px">
            <el-input v-model="formData.leftSideLimit" oninput="this.value=value.replace(/[^0-9]/g,'')" maxlength="5" placeholder="请输入上限的金额">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="右区间上调比例：" prop="rightSideRatio">
            <el-input v-model="formData.rightSideRatio" placeholder="请输不大于200的数字" @input="limitInput($event, 'rightSideRatio', 200)">
              <template slot="append">%</template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="最多上调：" prop="rightSideLimit" label-width="95px">
            <el-input v-model="formData.rightSideLimit" oninput="this.value=value.replace(/[^0-9]/g,'')" maxlength="5" placeholder="请输入上限的金额">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="confirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import _api from "@/utils/request";
export default {
  name: "FutureRuleDia",
  data() {
    const validateRange = (rule, value, callback) => {
      const { field } = rule
      const { lower, upper } = this.formData
      if (!lower || !upper) callback()
      if (lower >= upper) {
        if (field == 'lower') callback(new Error('起始值需小于结束值'))
        callback(new Error('结束值需大于起始值'))
      }
      callback()
    }
    const limitLenthVaild = (rule, value, callback) => {
      const number = Number(value)
      if (number < 0 || number > 100) {
        callback(new Error('请输入不大于100的数字'))
      }
      callback()
    }
    const limitLenthVaild_200 = (rule, value, callback) => {
      const number = Number(value)
      if (number < 0 || number > 200) {
        callback(new Error('请输入不大于200的数字'))
      }
      callback()
    }
    return {
      visible: false,
      loading: false,

      dialogType: '',
      formData: {
        lower: '',
        upper: '',
        leftSideRatio: '',
        leftSideLimit: '',
        rightSideRatio: '',
        rightSideLimit: ''
      },
      rules: {
        lower: [
          { required: true, message: '请输入起始值', trigger: 'blur' },
          { validator: validateRange, trigger: 'blur' }
        ],
        upper: [
          { required: true, message: '请输入结束值', trigger: 'blur' },
          { validator: validateRange, trigger: 'blur' }
        ],
        leftSideRatio: [
          { required: true, message: '请输入比例', trigger: 'blur' },
          { validator: limitLenthVaild, trigger: 'blur' }
        ],
        leftSideLimit: [
          { required: true, message: '请输入金额', trigger: 'blur' },
        ],
        rightSideRatio: [
          { required: true, message: '请输入比例', trigger: 'blur' },
          { validator: limitLenthVaild_200, trigger: 'blur' }
        ],
        rightSideLimit: [
          { required: true, message: '请输入金额', trigger: 'blur' },
        ],
      }
    };
  },
  methods: {
    open(row) {
      if (row) {
        this.dialogType = 'edit'
      } else {
        this.dialogType = 'add'
      }
      this.formData = row ? JSON.parse(JSON.stringify(row)) : {
        lower: '',
        upper: '',
        leftSideRatio: '',
        leftSideLimit: '',
        rightSideRatio: '',
        rightSideLimit: ''
      }
      this.visible = true
    },
    limitInput(value, name, max) {
        let str = (value && value.split("")) || [];
        let reg1 = /\d/;
        let reg2 = /\./;
        // 第一个字符不能为小数点
        if (str[0] == ".") {
            this.formData[name] = ""
            return;
        }
        // 过滤掉除数字和小数点外的字符
        value = str.filter((e) => reg1.test(e) || reg2.test(e));
        // 匹配小数点后只能有两位小数
        let valJoin = value.join("");
        // this.formData[name] =value.replace(/[^0-9]/g,'')
        this.formData[name] = valJoin.match(/^\d*(\.?\d{0,2})/g)[0] || "";
        if (this.formData[name] > max) {
          this.formData[name] = max
        }
    },
    confirm() {
      this.$refs['form'].validate((vaild) => {
        if (vaild) {
          this.$emit('confirm', this.dialogType, this.formData)
          this.visible = false
        }
      })
    },
  }
};
</script>

<style lang="scss" scoped>

</style>